import { client } from './client'
import Microtag from '../models/microtag'

export default {
  index (query) {
    return client.get('/microtags?include=macrotag', {
      params: query
    })
  },
  show (id) {
    return client.get('/microtags/' + id)
      .then((response) => {
        return new Microtag(response.data.data)
      })
  },
  store (data) {
    return client.post('/microtags', data.prepareForSend())
  },
  update (id, data) {
    return client.patch('/microtags/' + id, data.prepareForSend())
  },
  search (data, query) {
    return client.get('/microtags', {
      params: {
        filter: JSON.stringify(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    })
  },
  select (data) {
    let microtag = new Microtag()
    microtag.microtag = data
    return client.get('/microtags', {
      params: {
        filter: JSON.stringify(microtag),
        limit: 100,
        orderBy: 'microtag'
      }
    })
  },
  delete (id) {
    return client.delete('/microtags/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/microtags.js